import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom"
import Collections from './components/Collections';
import Swatch from './components/Swatch';
import Swatches from "./pages/SwatchesPage/Swatches";
import ErrorPage from "./pages/ErrorPage"
import SearchPage from './pages/SearchPage';
import SignIn from './pages/login';
import SwatchDetails from './pages/SwatchDetails';
import LiveCollectionPage from './pages/live-collection';
import SentSwatchesPage from './pages/sent';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Swatches />
      },
      {
        path: "/collection",
        element: <Collections />
      },
      {
        path: "/live-collection",
        element: <LiveCollectionPage />
      },
      {
        path: "/sent",
        element: <SentSwatchesPage />
      },
      {
        path: "/swatches",
        element: <Swatches />
      },
      {
        path: "/swatch/detail/:swatchId",
        element: <Swatch />
      },
      {
        path: "/swatch/:swatchId",
        element: <SwatchDetails />
      },
      {
        path: "home",
        element: <SearchPage />
      },
      {
        path: "/login",
        element: <SignIn  />
      }
    ],
    errorElement: <ErrorPage />,
  },
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <RouterProvider router={router} />
  // </React.StrictMode>
);


